// extracted by mini-css-extract-plugin
module.exports = {"Select":"_1rPbLLjqoDch2datb1AEwE"};